import type { BannerFromBackend, BannersFromBackend, TransformedBanner } from './types';

export function transformBanners(
  banners: BannersFromBackend,
): TransformedBanner[] {
  return banners.data.map(({ id, attributes }) => createBanner(id, attributes));
}

function createBanner(
  id: BannerFromBackend['id'],
  attributes?: BannerFromBackend['attributes'],
): TransformedBanner {
  const description = attributes?.description || '';
  const matchOfTheDayId = attributes?.matchOfTheDayId ? attributes?.matchOfTheDayId : null;

  return {
    id,
    description,
    matchOfTheDayId,
    weight: attributes?.weight || 0,
    title: attributes?.title,
    image: getImageUrl(attributes),
    isPreviewMode: typeof attributes?.publishedAt !== 'string',
    link: attributes?.link || null,
    promoId: attributes?.document || null,
    isPromo: attributes?.promo || false,
  };
}

function getImageUrl(attributes?: BannerFromBackend['attributes']) {
  const image = attributes?.image;

  if (!image) {
    return null;
  }

  return image.original || image.large || null;
}
